/** Page text cuts immediately. Only the dynamic media card blends for eight frames, at every fps. */
export const STORY_PAGE_EXIT_FRAMES = 8;
export function storyPageExitProgress(ageFrames: number, hasPrevious: boolean): number {
  return hasPrevious ? Math.min(1, Math.max(0, ageFrames / STORY_PAGE_EXIT_FRAMES)) : 1;
}
